export default __webpack_public_path__ + "static/media/Google-Maps-Logo.9e4a319a.png";